import { render } from "./TagSelect.vue?vue&type=template&id=3cde162d&scoped=true&ts=true"
import script from "./TagSelect.vue?vue&type=script&lang=ts"
export * from "./TagSelect.vue?vue&type=script&lang=ts"

import "./TagSelect.vue?vue&type=style&index=0&id=3cde162d&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cde162d"]])

export default __exports__